<template>
	<div class="tab">
		<div class="flex">
			<div class="title">{{ title }}</div>
			<p v-if="isShowTips">
				每个文件下载后，将为您保存72小时，点击
				<span class="donwload-btn" @click="goHistroy()">下载</span> 即可重新下载
			</p>
		</div>

		<slot></slot>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
		},
		isShowTips: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		//历史记录
		goHistroy() {
			this.$router.push({ path: "/downloadHistory" });
			this.$store.commit("headerMenuId", "downloadHistory");
			this.$store.commit("asideMenuId", "downloadHistory");
		}
	}
};
</script>
<style lang="scss" scoped>
.tab {
	padding: 30px;
	background: white;
	margin-bottom: 20px;

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.title {
		font-size: 20px;
	}

	p {
		color: #909399;
	}
}

.donwload-btn {
	color: white;
	background-color: #f56c6c;
	padding: 2px 6px;
	border-radius: 3px;
	margin: 0 4px;
	cursor: pointer;
}
</style>
